var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99984 0.166656C2.774 0.166656 0.166504 2.77416 0.166504 5.99999C0.166504 9.22582 2.774 11.8333 5.99984 11.8333C9.22567 11.8333 11.8332 9.22582 11.8332 5.99999C11.8332 2.77416 9.22567 0.166656 5.99984 0.166656ZM8.50817 8.50832C8.28067 8.73582 7.91317 8.73582 7.68567 8.50832L5.99984 6.82249L4.314 8.50832C4.0865 8.73582 3.719 8.73582 3.4915 8.50832C3.264 8.28082 3.264 7.91332 3.4915 7.68582L5.17734 5.99999L3.4915 4.31416C3.264 4.08666 3.264 3.71916 3.4915 3.49166C3.719 3.26416 4.0865 3.26416 4.314 3.49166L5.99984 5.17749L7.68567 3.49166C7.91317 3.26416 8.28067 3.26416 8.50817 3.49166C8.73567 3.71916 8.73567 4.08666 8.50817 4.31416L6.82234 5.99999L8.50817 7.68582C8.72984 7.90749 8.72984 8.28082 8.50817 8.50832Z",
    fill: "#FF4D4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCircle);
export default __webpack_public_path__ + "static/media/red-circle.b8ac3314e451350f1e922b4f666f5b6b.svg";
export { ForwardRef as ReactComponent };